import { FunctionComponent } from "react";

import PageLayout from "@components/core/layouts/PageLayout";
import { ROUTES } from "@routes/Routes";
import MySignaturesSection from "@views/core/extranet/menu/account/mySignature/MySignaturesSection";
import MyCertificateSection from "@views/core/extranet/menu/account/mySignature/MyCertificateSection";
import { useUnit } from "effector-react";
import { AuthenticationContext } from "@type/core/auth/auth.types";
import { authenticationStore } from "@state/auth/AuthStore";

const MySignatureScreen: FunctionComponent = () => {
  const authStore = useUnit<AuthenticationContext | null>(authenticationStore);
  const user = authStore?.user;

  return (
    <PageLayout container returnRoute={ROUTES.extranet.home.generate()}>
      <>
        <MySignaturesSection />
        {user?.certificateInfos && <MyCertificateSection />}
      </>
    </PageLayout>
  );
};

export default MySignatureScreen;
